export const Section = {
  contacts: 'contacts',
  aboutUs: 'aboutUs',
  anotherRestaurants: 'anotherRestaurants',
  ourKitchen: 'ourKitchen',
  bookTable: 'bookTable',
}
